var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone"},[_c('vs-tooltip',{staticClass:"flex",attrs:{"text":this.params
        ? this.params.data.basic_details.address.country.country_name
        : this.country_name,"color":"primary"}},[_c('country-flag',{staticClass:"phone-img",attrs:{"country":this.params
          ? this.params.data.basic_details.address.country.country_code
          : this.country_code,"size":"normal"}})],1),_c('div',[(!this.params)?_c('strong',{staticClass:"block pl-2"},[_vm._v("Contact:")]):_vm._e(),_c('span',{staticClass:"phone-number"},[_vm._v(_vm._s(this.params ? this.params.value : this.phone))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }